import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useState, useRef, useEffect } from 'react';
import { View, Text, TouchableOpacity, ScrollView, findNodeHandle, Dimensions } from 'react-native';
import styles from './styles';
import { useComponentTracking } from '../../../hooks/rn/useWebTracking';
import { gray_1 } from '../../../styles/rn';
import { TRACKING_OPERATION } from '../../../utils/tracking/constants';
export var TabsType;
(function (TabsType) {
  TabsType["noUnderscore"] = "noUnderscore";
  TabsType["underscore"] = "underscore";
  TabsType["userTypeUnderscore"] = "userTypeUnderscore";
})(TabsType || (TabsType = {}));
export var halfWindowWidth = Dimensions.get('window').width / 2;
export var NestedTabs = function NestedTabs(props) {
  var _levelOneSelectedInde, _levelOneSelectedInde2, _levelOneSelectedInde3;
  var _props$defaultSelecte = props.defaultSelected,
    defaultSelected = _props$defaultSelecte === void 0 ? 0 : _props$defaultSelecte,
    containerStyle = props.containerStyle,
    titleStyle = props.titleStyle,
    userTypeTitleContainerStyle = props.userTypeTitleContainerStyle,
    titleContainerStyle = props.titleContainerStyle,
    singleTitleContainerStyle = props.singleTitleContainerStyle,
    defaultTabTitleColor = props.defaultTabTitleColor,
    contentStyle = props.contentStyle,
    _props$type = props.type,
    type = _props$type === void 0 ? TabsType.noUnderscore : _props$type,
    _props$tabs = props.tabs,
    tabs = _props$tabs === void 0 ? [] : _props$tabs,
    userTypeTabs = props.userTypeTabs,
    renderTab = props.renderTab,
    componentTrackingData = props.componentTrackingData;
  var isOneLevelTabs = !userTypeTabs;
  var isTwoLevelTabs = userTypeTabs;
  var _useState = useState(isTwoLevelTabs ? 0 : defaultSelected),
    _useState2 = _slicedToArray(_useState, 2),
    levelOneSelectedIndex = _useState2[0],
    setLevelOneSelectedIndex = _useState2[1];
  var _useState3 = useState((userTypeTabs || []).reduce(function (prev, cur) {
      var userType = cur.userType;
      prev[userType.type] = defaultSelected;
      return prev;
    }, {})),
    _useState4 = _slicedToArray(_useState3, 2),
    levelTwoSelectedIndexMap = _useState4[0],
    setLevelTwoSelectedIndexMap = _useState4[1];
  var statusScrollViewRef = useRef(null);
  var selectedStatusTitleRef = useRef(null);
  var selectedUserType = (_levelOneSelectedInde = (userTypeTabs || [])[levelOneSelectedIndex]) === null || _levelOneSelectedInde === void 0 ? void 0 : (_levelOneSelectedInde2 = _levelOneSelectedInde.userType) === null || _levelOneSelectedInde2 === void 0 ? void 0 : _levelOneSelectedInde2.type;
  var userTypeTitles = (userTypeTabs || []).map(function (tabsInfo) {
    return tabsInfo.userType;
  });
  var levelTwoStatusTitles = ((_levelOneSelectedInde3 = (userTypeTabs || [])[levelOneSelectedIndex]) === null || _levelOneSelectedInde3 === void 0 ? void 0 : _levelOneSelectedInde3.tabs) || [];
  useEffect(function () {
    setTimeout(function () {
      if (statusScrollViewRef.current && selectedStatusTitleRef.current) {
        selectedStatusTitleRef.current.measureLayout(findNodeHandle(statusScrollViewRef.current), function (x, _, width) {
          var _statusScrollViewRef$, _statusScrollViewRef$2;
          (_statusScrollViewRef$ = statusScrollViewRef.current) === null || _statusScrollViewRef$ === void 0 ? void 0 : (_statusScrollViewRef$2 = _statusScrollViewRef$.scrollTo) === null || _statusScrollViewRef$2 === void 0 ? void 0 : _statusScrollViewRef$2.call(_statusScrollViewRef$, {
            x: x - halfWindowWidth + width / 2,
            animated: false
          });
        });
      }
    });
  }, [levelTwoStatusTitles]);
  var handleLevelOneTabChange = function handleLevelOneTabChange(index, title) {
    if (index === levelOneSelectedIndex || title.disabled) {
      return;
    }
    setLevelOneSelectedIndex(index);
  };
  var handleLevelTwoTabChange = function handleLevelTwoTabChange(index, title) {
    if (index === levelTwoSelectedIndexMap[selectedUserType] || title.disabled) {
      return;
    }
    setLevelTwoSelectedIndexMap(_objectSpread(_objectSpread({}, levelTwoSelectedIndexMap), {}, _defineProperty({}, selectedUserType, index)));
  };
  var renderTitle = function renderTitle(title, index) {
    var titleLevel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var _useComponentTracking = useComponentTracking({
        componentTrackingData: componentTrackingData,
        componentData: {
          title: title,
          index: index
        }
      }),
      tracker = _useComponentTracking.tracker,
      tabTracking = _useComponentTracking.result.tab;
    var isSelected = titleLevel === 1 && index === levelOneSelectedIndex || titleLevel === 2 && index === levelTwoSelectedIndexMap[selectedUserType];
    var isSelectedStatus = isSelected && isOneLevelTabs || isSelected && isTwoLevelTabs && titleLevel === 2;
    var showUnderscore = type === TabsType.underscore && isSelected || type === TabsType.userTypeUnderscore && isTwoLevelTabs && isSelected && titleLevel === 1;
    var props = {
      // Default tab to be visible
      ref: isSelectedStatus ? selectedStatusTitleRef : undefined,
      style: [isSelected && styles.selected, title.disabled && styles.disabled],
      onPress: function onPress() {
        if (titleLevel === 1) {
          handleLevelOneTabChange(index, title);
        } else {
          handleLevelTwoTabChange(index, title);
        }
        (tabTracking === null || tabTracking === void 0 ? void 0 : tabTracking.trackingClick) && tracker.click(tabTracking.trackingClick);
      }
    };
    isSelected && (tabTracking === null || tabTracking === void 0 ? void 0 : tabTracking.trackingClick) && tracker.click(_objectSpread(_objectSpread({}, tabTracking.trackingClick), {}, {
      operation: TRACKING_OPERATION.IMPRESSION
    }));
    return /*#__PURE__*/React.createElement(TouchableOpacity, {
      key: title.name,
      onPress: props.onPress,
      style: [userTypeTabs && titleLevel === 1 && {
        flex: 1
      }]
    }, /*#__PURE__*/React.createElement(View, {
      ref: props.ref,
      style: [showUnderscore && styles.selectedWithUnderscore, singleTitleContainerStyle]
    }, /*#__PURE__*/React.createElement(Text, {
      style: [styles.tabsTitle, {
        color: defaultTabTitleColor !== null && defaultTabTitleColor !== void 0 ? defaultTabTitleColor : gray_1
      }, props.style, titleStyle]
    }, title.name)));
  };
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.tabsContainer, containerStyle]
  }, userTypeTabs ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
    style: [styles.tabsTitleContainer, styles.userTypeTitleContainerStyle, titleContainerStyle, userTypeTitleContainerStyle]
  }, userTypeTitles.map(function (title, index) {
    return renderTitle(title, index, 1);
  })), /*#__PURE__*/React.createElement(ScrollView, {
    horizontal: true,
    showsHorizontalScrollIndicator: false,
    style: [styles.tabsTitleContainer, titleContainerStyle],
    ref: statusScrollViewRef
  }, levelTwoStatusTitles.map(function (title, index) {
    return renderTitle(title, index, 2);
  }))) : /*#__PURE__*/React.createElement(ScrollView, {
    horizontal: true,
    showsHorizontalScrollIndicator: false,
    style: [styles.tabsTitleContainer, titleContainerStyle],
    ref: statusScrollViewRef
  }, tabs.map(function (title, index) {
    return renderTitle(title, index);
  })), /*#__PURE__*/React.createElement(View, {
    style: [styles.tabsContentContainer, contentStyle]
  }, isTwoLevelTabs ? userTypeTabs.map(function (tabsInfo) {
    return tabsInfo.tabs.map(function (tab) {
      return renderTab({
        userType: tabsInfo.userType.type,
        status: tab.type,
        currentUserType: selectedUserType,
        currentStatus: levelTwoStatusTitles[levelTwoSelectedIndexMap[selectedUserType]].type
      });
    });
  }).flat() : tabs.map(function (tab) {
    return renderTab({
      status: tab.type,
      currentStatus: tabs[levelOneSelectedIndex].type
    });
  })));
};